
import Vue from "vue";

export default Vue.extend({
  name: "Navv",
  data: () => ({
    mins: [
      {
        title: "navBar.servicesList.link1",
        pragraph: "navBar.servicesList.desc1",
        path: "/services",
      },
      {
        title: "navBar.servicesList.link2",
        pragraph: "navBar.servicesList.desc2",
        path: "/services",
      },
      {
        title: "navBar.servicesList.link3",
        pragraph: "navBar.servicesList.desc3",
        path: "/services",
      },
    ],
    mins2: [
      {
        title: "navBar.servicesList.link4",
        pragraph: "navBar.servicesList.desc4",
        path: "/services",
      },
      {
        title: "navBar.servicesList.link5",
        pragraph: "navBar.servicesList.desc5",
        path: "/services",
      },
      {
        title: "navBar.servicesList.link6",
        pragraph: "navBar.servicesList.desc6",
        path: "/services",
      },
    ],
    mins3: [
      {
        title: "navBar.productsList.link1",
        pragraph: "navBar.productsList.desc1",
        path: "/system",
      },
      {
        title: "navBar.productsList.link2",
        pragraph: "navBar.productsList.desc2",
        path: "/systemTow",
      },
    ],
    navSettings: {
      view: true,
      absolute: false,
    },
  }),
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler() {
        localStorage.setItem("lang", this.$i18n.locale);
        console.log(this.$i18n.locale);
        if (this.$i18n.locale == "ar") {
          this.$vuetify.rtl = true;
        } else {
          this.$vuetify.rtl = false;
        }
      },
    },

    $route: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        try {
          const that = this as any;
          // nav settings based on the current page
          if (newVal && newVal.meta && newVal.meta.nav) {
            that.navSettings.view = newVal.meta.nav.view;
            that.navSettings.absolute = newVal.meta.nav.absolute;
          }
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
  methods: {
    toggle() {
      const that = this as any;
      const val = that.$vuetify.breakpoint.name;
      let drawer = Object.assign({}, that.$store.state.drawerAll); // copy of the object
      if (val == "xs" || val == "sm" || val == "md") {
        drawer.view = !drawer.view;
      } else {
        drawer.mini = !drawer.mini;
      }
      that.$store.commit("get_drawer", drawer);
    },
  },
  computed: {
    btnWidth() {
      const that = this as any;
      return that.$vuetify.breakpoint.name == "xl" ||
        that.$vuetify.breakpoint.name == "lg"
        ? "140px"
        : "90px";
    },
    btnHeight() {
      const that = this as any;
      return that.$vuetify.breakpoint.name == "xl" ||
        that.$vuetify.breakpoint.name == "lg"
        ? "55px"
        : "34px";
    },
  },
});
